import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StateProvincesPipe } from './pipes/state-provinces.pipe';
import { FlowUpLabelDirective } from './directives/flow-up-label.directive';
import { LineItemsPipe } from './pipes/line-items.pipe';

@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [ StateProvincesPipe, FlowUpLabelDirective, LineItemsPipe],
  exports:[
    CommonModule,
    StateProvincesPipe,
    FlowUpLabelDirective,
    LineItemsPipe
  ]
})
export class SharedModule { }
